import classnames from 'classnames/bind'
import { head, isEmpty, noop } from 'lodash'
import PropTypes from 'prop-types'
import React, { Component } from 'react'
import StringUtil from 'utilities/string_util'
import styles from './file_selector.module.scss'
import FileSelectorModal from './file_selector_modal'

const cx = classnames.bind(styles)

export default class FileSelector extends Component {
  constructor(props) {
    super(props)

    this.state = {
      file: null,
      isOpened: false
    }
  }

  static getDerivedStateFromProps(nextProps, prevState) {
    if (prevState.value !== null && nextProps.value === null) {
      return {
        file: null
      }
    }

    return prevState
  }

  componentDidUpdate() {
    const { value } = this.props
    const { file } = this.state

    if (value === null && file === null) {
      this.input.value = null
    }
  }

  handleChangeFile(e) {
    const { onChange, fileSizeLimit } = this.props
    let file = head(e.target.files) || null

    const isSizeCheck = fileSizeLimit > 0
    const isSizeOver = file && isSizeCheck ? file.size > fileSizeLimit : false
    if (isSizeOver) {
      this.input.value = null
      file = null
    }

    const blobUrl = file ? window.URL.createObjectURL(file) : null
    this.setState({ file, isOpened: isSizeOver })
    onChange({ file, blobUrl })
  }

  closeModal() {
    this.setState({
      isOpened: false
    })
  }

  render() {
    const { file, isOpened } = this.state
    const { accept, className, fileNameClassName, name, disabled, value, fileSizeLimit } = this.props
    const formId = StringUtil.getRandomString()
    const uploadedFileName = (file && file.name) || null
    const fileName = file === null ? null : uploadedFileName

    return (
      <div
        className={cx(className, styles.fileSelector, {
          fileSelectorActive: file !== null
        })}
      >
        <label className={styles.btnUpload} htmlFor={formId}>
          {I18n.t('components.file_selector.label')}
        </label>
        <div className={cx(fileNameClassName, styles.fileName)}>
          {isEmpty(value) && !fileName ? I18n.t('components.file_selector.message.select') : fileName}
        </div>
        <input
          type="file"
          className={styles.fileControl}
          accept={accept}
          name={name}
          id={formId}
          ref={ref => {
            this.input = ref
          }}
          disabled={disabled}
          onChange={e => this.handleChangeFile(e)}
        />
        <FileSelectorModal isOpened={isOpened} onClick={() => this.closeModal()} fileSizeLimit={fileSizeLimit} />
      </div>
    )
  }
}

FileSelector.propTypes = {
  className: PropTypes.string,
  fileNameClassName: PropTypes.string,
  name: PropTypes.string.isRequired,
  accept: PropTypes.string,
  value: PropTypes.string,
  disabled: PropTypes.bool,
  fileSizeLimit: PropTypes.number,
  onChange: PropTypes.func
}

FileSelector.defaultProps = {
  accept: null,
  className: null,
  fileNameClassName: null,
  value: '',
  disabled: false,
  fileSizeLimit: 0,
  onChange: noop
}
